// src/api/http.js
import axios from 'axios';

const api = axios.create({
    baseURL: '/api',
    withCredentials: true,
    timeout: 15000,
});

// Không để Promise treo; chỉ redirect nếu đang ở /admin rồi reject bình thường
api.interceptors.response.use(
    (res) => res,
    (err) => {
        const status = err?.response?.status;
        if (status === 401) {
            const onAdminPage = window.location.pathname.startsWith('/admin');
            if (onAdminPage) {
                // ép sang login cho khu vực admin
                window.location.replace('/login');
            }
            // Quan trọng: luôn trả lỗi về cho caller -> không “đứng hình”
            return Promise.reject(err);
        }
        return Promise.reject(err);
    }
);

export default api;
